<template>
    <div class="view budget-budget">
        <app-sub-navbar parent="budget"></app-sub-navbar>
        <div v-if="loaded">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-12">
                        <app-budget-graph ref="graph"></app-budget-graph>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <app-budget-main ref="main" @openBudget="openBudget" @saved="saveMain" @dateChanged="reloadData" :saveButtonDisabled="mainOpen"></app-budget-main>
                    </div>
                </div>
                <div class="row mt-50" ref="stickyRow">
                    <div class="col-12">
                        <app-store-budgets :class="{ 'table-fixed-header': isFixed }" ref="store" @saved="saveStore" @storeBudgetChanged="getTotalHoursBadgeMain" :saveButtonDisabled="storeOpen"></app-store-budgets>
                    </div>
                </div>
                <div class="row mt-50">
                    <div class="col-12">
                        <app-budget-summary :progress="progress" ref="summary" :saveButtonDisabled="summaryOpen"></app-budget-summary>
                    </div>
                </div>
            </div>
        </div>
        <div class="container-fluid" v-else>
            <el-card class="box-card">
                <div class="card-body no-padding">
                    <div class="loader-container" >
                        <facebook-loader :speed="3" :animate=true :height=130 :width=400></facebook-loader>
                    </div>
                </div>
            </el-card>
        </div>
    </div>
</template>

<script>
import SubNavbar from '../../components/SubNavbar'
import StoreBudgets from '../../components/budget/StoreBudgets'
import Budget from '../../components/budget/Budget'
import BudgetSummary from '../../components/budget/BudgetSummary'
import BudgetGraph from '../../components/budget/BudgetGraph2'
import { serialize } from '../../functions'
import { FacebookLoader } from 'vue-content-loader'
import moment from 'moment'

function getWeekNumber (d) {
    d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()))
    d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7))
    var yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1))
    var weekNo = Math.ceil((((d - yearStart) / 86400000) + 1) / 7)
    console.log(yearStart, weekNo)
    if (moment(yearStart).year() > 2020) {
        weekNo -= 1
    }
    return [d.getUTCFullYear(), weekNo]
}

export default {
    data () {
        return {
            loaded: false,
            mainComponentSaved: false,
            storeComponentSaved: false,
            budgetParamsGiven: false,
            isFixed: false
        }
    },
    components: {
        appSubNavbar: SubNavbar,
        appStoreBudgets: StoreBudgets,
        appBudgetMain: Budget,
        appBudgetSummary: BudgetSummary,
        appBudgetGraph: BudgetGraph,
        FacebookLoader
    },
    watch: {
        '$route.query' () {
            this.mainComponentSaved = false
            this.opened = false
            this.reloadData()
        }
    },
    computed: {
        mainOpen () {
            if (this.mainComponentSaved === true) {
                return true
            } else {
                return false
            }
        },
        storeOpen () {
            if (this.mainComponentSaved === true && this.storeComponentSaved === false) {
                return false
            } else {
                return true
            }
        },
        summaryOpen () {
            if (this.mainComponentSaved === true && this.storeComponentSaved === true) {
                return false
            } else {
                return true
            }
        },
        progress () {
            if (this.mainComponentSaved === false) {
                return 1
            } else if (this.mainComponentSaved === true && this.storeComponentSaved === false) {
                return 2
            } else if (this.mainComponentSaved === true && this.storeComponentSaved === true) {
                return 3
            } else {
                return 4
            }
        }
    },
    methods: {
        reloadData () {
            this.loaded = false
            let promiseList = [this.$store.dispatch('budget/getBudget', { 'route': serialize(this.$route.query) + '&org_id=' + localStorage.getItem('org_id') + '&context=true' }), this.$store.dispatch('budget/getPrediction', { 'route': serialize(this.$route.query) + '&org_id=' + localStorage.getItem('org_id') + '&context=true' })]
            Promise.all(promiseList).then(response => {
                this.$store.commit('budget/SET_MANUAL_HOUR_CHANGES', { 'factor': 1, 'updateHours': false, 'correctMinimum': false, 'initialLoad': true })
                this.$store.commit('budget/SET_PREDICTION_SUMS')
                this.loaded = true
            })
                .catch(error => {
                    console.log(error)
                })
        },
        getTotalHoursBadgeMain () {
            this.$refs.main.updateBadgeValues()
        },
        saveMain () {
            this.mainComponentSaved = true
            this.opened = false
        },
        saveStore () {
            this.storeComponentSaved = true
        },
        openBudget () {
            this.mainComponentSaved = false
            this.storeComponentSaved = false
        },
        handleScroll () {
            // Get the y position of the table relative to the user window.
            const rowPosition = this.$refs['stickyRow'].getBoundingClientRect().y
            // If negative, we've already passed the table, so isFixed=true
            this.isFixed = rowPosition < 0
        }
    },
    mounted () {
        let promiseList = []
        // if (Object.keys(this.$store.state.budget.regressionParameters).length === 0) {
        //     promiseList.push(this.$store.dispatch('budget/getRegressionParameters'))
        // }
        if (this.$store.state.budget.levels.length === 0) {
            promiseList.push(this.$store.dispatch('budget/getLevels'))
        }
        // Check if right budgets are loaded
        if ((this.$store.state.budget.budget.length > 0 && this.$store.state.budget.budget[0].week === this.$route.query.week && this.$store.state.budget.budget[0].year === this.$route.query.year && this.$store.state.budget.budget[0].level === this.$route.query.level) === false) {
            promiseList.push(this.$store.dispatch('budget/getBudget', { 'route': serialize(this.$route.query) + '&context=true' }))
        }
        // Check if right predictions are loaded
        if ((this.$store.state.budget.prediction.length > 0 && this.$store.state.budget.prediction[0].week === this.$route.query.week && this.$store.state.budget.prediction[0].year === this.$route.query.year && this.$store.state.budget.prediction[0].level === this.$route.query.level) === false) {
            promiseList.push(this.$store.dispatch('budget/getPrediction', { 'route': serialize(this.$route.query) + '&context=true' }))
        }
        if (promiseList.length > 0) {
            // Execute all the actions
            Promise.all(promiseList)
                .then(response => {
                    this.$store.commit('budget/SET_INITIAL_HOUR_CHANGE')
                    // Set initial manual hour change
                    this.$store.commit('budget/SET_MANUAL_HOUR_CHANGES', { 'factor': 1, 'updateHours': false, 'correctMinimum': false, 'initialLoad': true })
                    // Calculate the sums
                    this.$store.commit('budget/SET_PREDICTION_SUMS')

                    // Now we can load the store context, since the store_ids are known
                    let stores = this.$store.state.budget.budget.map(b => b.store_id)
                    this.$store.dispatch('budget/getContextStoreBudget', stores)
                        .then(response => {
                            this.loaded = true
                        })
                        .catch(error => {
                            console.log(error)
                        })
                })
                .catch(error => {
                    console.log(error)
                })
        } else {
            this.$store.commit('budget/SET_INITIAL_HOUR_CHANGE')
            // Set initial manual hour change and correct budgets that are under min hours
            this.$store.commit('budget/SET_MANUAL_HOUR_CHANGES', { 'factor': 1, 'updateHours': false, 'correctMinimum': false, 'initialLoad': true })
            // Calculate the sums
            this.$store.commit('budget/SET_PREDICTION_SUMS')

            // Now we can load the store context, since the store_ids are known
            let stores = this.$store.state.budget.budget.map(b => b.store_id)
            this.$store.dispatch('budget/getContextStoreBudget', stores)
                .then(response => {
                    this.loaded = true
                })
                .catch(error => {
                    console.log(error)
                })
        }
    },
    created () {
        let date = new Date()
        let minLevel = 999
        for (let item of localStorage.getItem('roles').split(',')) {
            if (item > 100 && item < minLevel) {
                minLevel = item
            }
        }
        minLevel -= 100
        if (Object.keys(this.$route.query) < 2) {
            this.$router.push({ name: 'budget-budget', query: { level: minLevel, year: getWeekNumber(date)[0], week: getWeekNumber(date)[1] } })
        } else {
            this.budgetParamsGiven = true
        }

        window.addEventListener('scroll', this.handleScroll)
    },
    destroyed () {
        window.removeEventListener('scroll', this.handleScroll)
    }
}
</script>

<style lang="scss">
.table-fixed-header .el-table__header {
    position: fixed;
    top: 0px;
    z-index: 1;
}
</style>
